import {Component, Input, OnInit} from '@angular/core';
import {type} from 'os';

@Component({
  selector: 'app-edit-cmp',
  templateUrl: './edit-cmp.component.html',
  styleUrls: ['./edit-cmp.component.scss']
})
export class EditCmpComponent implements OnInit {

  @Input() data: any;
  columns: string [] = [];
  constructor() { }

  ngOnInit() {
      this.getItems();
  }
  saveApi() {
  }
  getItems() {
  // for (const item of this.data) {
  //   this.columns = [];
    for (const itemval in this.data) {
      this.columns.push(itemval);
    // }
  }
  }
  deletearrayColumn(a, column) {
    if (this.data[column].length > 1) {
      this.data[column].splice(a, 1);
    }
  }
  addColumn(data) {
    let temp: any;
    temp = JSON.parse(JSON.stringify(data[0]));
    data.push(temp);
  }
  typeof(object) {
    let stringConstructor = 'test'.constructor;
    let arrayConstructor = [].constructor;
    let objectConstructor = ({}).constructor;

    if (object === null) {
      return 'null';
    }
    if (object === undefined) {
      return 'undefined';
    }
    if (object.constructor === stringConstructor) {
      return 'String';
    }
    if (object.constructor === arrayConstructor) {
      return 'array';
    }
    if (object.constructor === objectConstructor) {
      return 'object';
    }
    {
      return 'don\'t know';
    }
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
}
